import { Typography } from "@material-ui/core";

export function BulletList({ children }: any) {
  return <Typography variant="body1">{children}</Typography>;
}
